import React from 'react';
import { CheckCircle2, BookHeart } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-rose-50 to-white pt-12 pb-16 md:pt-20 md:pb-24 px-4" data-id="element-75">
      <div className="mx-auto max-w-6xl" data-id="element-76">
        <div className="grid gap-12 md:grid-cols-2 md:items-center" data-id="element-77">
          {/* Text Content */}
          <div className="space-y-8 text-center md:text-left" data-id="element-78">
            <div className="space-y-4" data-id="element-79">
              <span className="inline-block rounded-full bg-rose-100 px-4 py-1.5 text-sm font-semibold text-rose-700" data-id="element-80">
                Para mujeres que quieren ser escuchadas
              </span>
              <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 md:text-5xl lg:text-6xl leading-tight" data-id="element-81">
                Di Esto, <span className="text-rose-600" data-id="element-82">No Aquello™</span>:
                Cómo Ser Escuchada Sin Pelear
              </h1>
              <p className="text-xl text-gray-600 md:text-2xl" data-id="element-83">
                El ebook práctico para mujeres que quieren comunicarse con
                seguridad, sin discusiones ni desgaste emocional.
              </p>
            </div>

            <ul className="space-y-3 text-left mx-auto md:mx-0 max-w-md" data-id="element-84">
              {['Frases listas para usar en mensajes y conversaciones', 'Evita peleas innecesarias y malentendidos', 'Comunica tus límites sin sentir culpa'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-85">
                  <CheckCircle2 className="h-6 w-6 flex-shrink-0 text-rose-500" data-id="element-86" />
                  <span className="text-gray-700 font-medium" data-id="element-87">{item}</span>
                </li>)}
            </ul>

            <div className="pt-4" data-id="element-88">
              <CTAButton fullWidth className="md:w-auto shadow-rose-200" onClick={() => window.open('https://pay.hotmart.com/H104303411I?checkoutMode=10', '_blank')} data-id="element-89">
                Quiero Ser Escuchada Ahora
              </CTAButton>
              <p className="mt-3 text-sm text-gray-500" data-id="element-90">
                Descarga inmediata • Garantía de 14 días
              </p>
            </div>
          </div>

          {/* Visual/Mockup */}
          <div className="relative mx-auto w-full max-w-sm md:max-w-md" data-id="element-91">
            <div className="relative" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" alt="Portada del ebook Di Esto, No Aquello™ — Cómo ser escuchada sin pelear" className="w-full rounded-2xl shadow-2xl rotate-1 md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-93" />
              {/* Decorative glow behind the book */}
              <div className="absolute -top-6 -right-6 h-32 w-32 rounded-full bg-yellow-100 opacity-40 blur-2xl -z-10" data-id="element-94"></div>
              <div className="absolute -bottom-8 -left-8 h-40 w-40 rounded-full bg-rose-200 opacity-40 blur-2xl -z-10" data-id="element-95"></div>
            </div>
            {/* Price anchor */}
            <div className="mt-6 text-center" data-id="element-96">
              <span className="text-gray-400 line-through text-lg" data-id="element-97">$47.00</span>
              <span className="ml-3 text-3xl font-extrabold text-rose-600" data-id="element-98">
                $9.99
              </span>
              <p className="mt-1 text-sm text-gray-500 font-medium" data-id="element-99">
                Precio de lanzamiento por tiempo limitado
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}